export default __webpack_public_path__ + "static/braids-f504e6c9e443316a887fd4f6fe1bb752.png";